module.exports = __webpack_public_path__ + "static/media/picture 2 - RR expertise.e9adb687.png";